import { render, staticRenderFns } from "./BookingDetailVisa.vue?vue&type=template&id=2ada0624&scoped=true"
import script from "./BookingDetailVisa.vue?vue&type=script&lang=js"
export * from "./BookingDetailVisa.vue?vue&type=script&lang=js"
import style0 from "./BookingDetailVisa.vue?vue&type=style&index=0&id=2ada0624&prod&lang=less&scoped=true"
import style1 from "./BookingDetailVisa.vue?vue&type=style&index=1&id=2ada0624&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ada0624",
  null
  
)

export default component.exports